export const ControlActionTypes = {
  LOAD_CONTROLS_START: '[controls] LOAD_CONTROLS_START',
  LOAD_CONTROLS_SUCCESS: '[controls] LOAD_CONTROLS_SUCCESS',
  LOAD_CONTROLS_FAILURE: '[controls] LOAD_CONTROLS_FAILURE',
};
